import PlaybooksCardListView from 'card-playbooks-lib/components/PlaybooksCardListView';
import useCardListViewModel from 'card-playbooks-lib/state/cardList/useCardListViewModel';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { objectTypes, pluralTypeToSingularUpperCase } from '../../../constants/types';
import { buildOpenPlaybookUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const crmPlaybooksService = {
  fetchPlaybooks: () => Promise.resolve({
    total: 0,
    offset: 0,
    results: []
  }),
  fetchRecommendedPlaybooks: () => Promise.resolve([]),
  get scopes() {
    return ['playbooks-read'];
  },
  playbookListLimit: 4,
  logInteraction: () => null,
  openPlaybook: __arg => null
};
function PlaybookList({
  selectedObjectType = objectTypes.contacts,
  selectedObjectId,
  fromModal,
  apiWrapper,
  openUrl,
  portalId,
  callObjectId,
  usageTracker
}) {
  const trackType = fromModal ? 'modal' : 'tab';
  crmPlaybooksService.logInteraction = () => {
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.playbooks,
      type: trackType
    }, ACTIONS.playbooks.clickPlaybook));
  };
  crmPlaybooksService.openPlaybook = playbookId => {
    const url = buildOpenPlaybookUrl({
      portalId,
      playbookId,
      selectedObjectType,
      selectedObjectId,
      callObjectId
    });
    usageTracker.trackUsage(Object.assign({
      screen: SCREENS.playbooks,
      type: trackType,
      playbookId
    }, ACTIONS.playbooks.openPlaybook));
    openUrl(url);
  };
  crmPlaybooksService.fetchPlaybooks = apiWrapper.fetchPlaybooks;
  crmPlaybooksService.fetchRecommendedPlaybooks = apiWrapper.fetchRecommendedPlaybooks;
  const [state, actions] = useCardListViewModel({
    service: crmPlaybooksService,
    objectType: pluralTypeToSingularUpperCase[selectedObjectType],
    objectId: Number(selectedObjectId)
  });
  return /*#__PURE__*/_jsx(PlaybooksCardListView, {
    state: state,
    actions: actions
  });
}
export default PlaybookList;